import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-desc',
  templateUrl: './desc.component.html',
  styleUrls: ['./desc.component.scss']
})
export class DescComponent implements OnInit {

  moreText: boolean = false;

  constructor() { }

  ngOnInit() {
  }

}
